import { Heading } from '@depop/web-thrift-ui/Typography';
import { CancelIcon } from '@depop/web-ui-kit/Icons/CancelIcon';

import { UpfrontShippingBanner } from '../UpfrontShippingBanner';

import styles from './styles.module.css';

export function OfferModalHeader({
  title,
  onClose,
  id,
  displayBanner = true,
}: {
  title: string;
  onClose: () => void;
  id?: string;
  displayBanner?: boolean;
}) {
  return (
    <>
      {displayBanner && <UpfrontShippingBanner />}
      <div className={styles.offerModalTitleRow}>
        <Heading variant="md" as="h2" id={id}>
          {title}
        </Heading>
        <button className={styles.closeButton} onClick={onClose}>
          <CancelIcon title="Close" aria-label="Close" />
        </button>
      </div>
    </>
  );
}
